import React from "react";
import { Route, Routes } from "react-router-dom";
import TesteCegoSitePropostasPoliticas from "../apps/teste-cegoSitePropostasPoliticas/Teste-cegoSitePropostasPoliticas";

function PaginaNaoEncontrada() {
  return <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f8f5ec", color: "#293534" }}><div style={{ textAlign: "center" }}><h1 style={{ fontFamily: "Georgia, serif" }}>Página não encontrada.</h1><a href="/" style={{ color: "#0f5b62", fontWeight: 800 }}>Voltar ao teste</a></div></main>;
}

export default function TesteCegoRoutes() {
  return <Routes><Route path="/" element={<TesteCegoSitePropostasPoliticas />} /><Route path="*" element={<PaginaNaoEncontrada />} /></Routes>;
}
